import { fetchUserOptionalProfileApi } from 'api/profile/fetchUserProfileApi'
import { ProfileStatus } from 'api/profile/profile.functions'

const FETCH_OPTIONAL_STATUSES = 'FETCH_OPTIONAL_STATUSES'

export const fetchProfileOptionalAction = (
  profileId: number,
  statuses: ProfileStatus[]
) => ({
  type: FETCH_OPTIONAL_STATUSES,
  promise: () => fetchUserOptionalProfileApi(profileId, statuses),
})
